import React from "react";

export const VowAmount = ({ data }) => {
  return (
    <div className="d-flex flex-column gap-3 col-md-5 mt-0">
      {/* Payment Details */}
      {/* <div className="roles-bg rounded-4  mt-0">
        <div className="d-flex ac-js gap-2 mt-2">
          <h2 className="d-flex f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 ">
            Payment Details
          </h2>
        </div>
        <div className="d-flex as-jb mt-3">
          <p className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 text-gray col-md-6">
            Total Price
          </p>
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
            {" "}
            : {data?.total_price}
          </p>
        </div>
        <div className="d-flex as-jb mt-3">
          <p className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 text-gray col-md-6">
            Property Owner(A)
          </p>
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
            {" "}
            : {data?.property_owner_amount}
          </p>
        </div>
        <div className="d-flex as-jb mt-3">
          <p className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 text-gray col-md-6">
            Vow Commission (B)
          </p>
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
            {" "}
            : {data?.vow_commission}
          </p>
        </div>
        <div className="d-flex as-jb mt-3">
          <p className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 text-gray col-md-6">
            Tips (C)
          </p>
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
            {" "}
            : {data?.tips}
          </p>
        </div>
        <div className="d-flex as-jb mt-3">
          <p className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 text-gray col-md-6">
            TDS (D)
          </p>
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
            {" "}
            : {data?.tds}
          </p>
        </div>
        <div
          style={{ backgroundColor: "#DDFFC4", borderRadius: "5px" }}
          className="d-flex as-jb mt-3 px-2 py-1"
        >
          <p className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 text-gray col-md-6">
            User Paid (B+C+D)
          </p>
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
            {" "}
            : {data?.user_paid_amount}
          </p>
        </div>
      </div> */}
      <div className="roles-bg rounded-4 p-3 mt-0">
        <div className="d-flex ac-js gap-2">
          <h2 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0">
            Payment Details
          </h2>
        </div>

        {/* Total Price */}
        <div className="d-flex justify-content-between align-items-center mt-3">
          <p className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 text-gray mb-0">
            Total Price
          </p>

          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray2 mb-0">
            : ₹{Number(data?.total_price || 0).toFixed(2)}
          </p>
        </div>

        {/* Property Owner */}
        <div className="d-flex justify-content-between align-items-center mt-3">
          <p className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 text-gray mb-0">
            Property Owner
          </p>

          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray2 mb-0">
            : ₹{Number(data?.property_owner_amount || 0).toFixed(2)}
          </p>
        </div>

        {/* Vow Commission */}
        <div className="d-flex justify-content-between align-items-center mt-3">
          <p className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 text-gray mb-0">
            Vow Commission
          </p>

          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray2 mb-0">
            : ₹{Number(data?.vow_commission || 0).toFixed(2)}
          </p>
        </div>

        {/* Tips */}
        <div className="d-flex justify-content-between align-items-center mt-3">
          <p className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 text-gray mb-0">
            Tips
          </p>

          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray2 mb-0">
            : ₹{Number(data?.tips || 0).toFixed(2)}
          </p>
        </div>

        {/* Vow Amount */}
        <div className="d-flex justify-content-between align-items-center mt-3">
          <p className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 text-gray mb-0">
            Total Vow Amount
          </p>

          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray2 mb-0">
            : ₹{Number(data?.vow_amount || 0).toFixed(2)}
          </p>
        </div>

        {/* Coupon */}
        <div className="d-flex justify-content-between align-items-center mt-3">
          <p className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 text-gray mb-0">
            Coupon
          </p>

          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray2 mb-0">
            : -₹{Number(data?.coupon || 0).toFixed(2)}
          </p>
        </div>

        {/* Wallet */}
        <div className="d-flex justify-content-between align-items-center mt-3">
          <p className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 text-gray mb-0">
            Wallet
          </p>

          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray2 mb-0">
            : -₹{Number(data?.wallet || 0).toFixed(2)}
          </p>
        </div>

        {/* User Paid */}
        <div
          style={{
            backgroundColor: "#DDFFC4",
            borderRadius: "8px",
          }}
          className="d-flex justify-content-between align-items-center mt-3 px-2 py-2"
        >
          <p className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 text-dark mb-0">
            User Paid
          </p>

          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 text-dark mb-0">
            : ₹{Number(data?.user_paid || 0).toFixed(2)}
          </p>
        </div>
      </div>

      {/* Advance Payment Details*/}
      {/* {data?.isAdv && (
        <div className="roles-bg rounded-4  mt-0">
          <div className="d-flex ac-js gap-2 mt-2">
            <h2 className="d-flex f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 ">
              Advance Payment Details
            </h2>
          </div>
          <div className="d-flex as-jb mt-3">
            <p className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 text-gray col-md-6">
              Razer Pay (E)
            </p>
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
              {" "}
              : {data?.razoypay_paid_amount}
            </p>
          </div>
          <div className="d-flex as-jb mt-3">
            <p className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 text-gray col-md-6">
              Coupon (H)
            </p>
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
              {" "}
              : {data?.coupon}
            </p>
          </div>
          <div className="d-flex as-jb mt-3">
            <p className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 text-gray col-md-6">
              Wallet (G)
            </p>
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
              {" "}
              :{data?.wallet}
            </p>
          </div>
        </div>
      )} */}

      {/* VOW Profit Amount Without TDS */}
      {/* <div className="roles-bg rounded-4  mt-0">
        <div className="d-flex ac-js gap-2 mt-2">
          <h2 className="d-flex f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 ">
            VOW Profit Amount Without TDS
          </h2>
        </div>
        <div className="d-flex as-jb mt-3">
          <p className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 text-gray col-md-6">
            Vow Commission (B)
          </p>
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
            {" "}
            : {data?.vow_commission}
          </p>
        </div>
        <div className="d-flex as-jb mt-3">
          <p className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 text-gray col-md-6">
            Tips (C)
          </p>
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
            {" "}
            : {data?.tips}
          </p>
        </div>

        <div
          style={{ backgroundColor: "#DDFFC4", borderRadius: "5px" }}
          className="d-flex as-jb mt-3 px-2 py-1"
        >
          <p className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 text-gray col-md-6">
            VOW Profit [F=B+C]
          </p>
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
            {" "}
            : {data?.vow_profit_with_tips}
          </p>
        </div>
      </div> */}
    </div>
  );
};
